import { render } from "./FlowContent.vue?vue&type=template&id=37b031ea&scoped=true"
import script from "./FlowContent.vue?vue&type=script&lang=js"
export * from "./FlowContent.vue?vue&type=script&lang=js"

import "./FlowContent.vue?vue&type=style&index=0&id=37b031ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b031ea"]])

export default __exports__